import "./Share.css"
import React from 'react'
import { observer, inject } from "mobx-react"

import { objectToGetParams } from '../lib/utils'

const twitter = (url, { title, via, hashtags = [] }) => {
  return 'https://twitter.com/share' + objectToGetParams({
    url,
    text: title,
    via,
    hashtags: hashtags.join(','),
  })
}

const facebook = (url, { title, description, picture, hashtag })=> {
  return 'https://facebook.com/sharer.php' + objectToGetParams({
    u: url,
    title,
    description,
    picture,
    hashtag,
  })
}

const pinterest = (url, { media, description })=> {
  return 'https://pinterest.com/pin/create/button/' + objectToGetParams({
    url,
    media,
    description,
  })
}

const ShareLink = ({url, children, color})=> {
  return <a 
    className="ShareLink"
    href={url} 
    style={{color}}
    target="_blank">{children}</a>
}

const Share = ({app, code})=> {

  const url = app.url
  const data = app.shareMeta

  return <div className="Share">
    <ShareLink url={twitter(url, data)} color="#0084b4">Tweet it</ShareLink>
    <ShareLink url={facebook(url, data)} color="#3b5998">Facebook it</ShareLink>
    <ShareLink url={pinterest(url, data)} color="#bd081c">Pin it</ShareLink>
  </div>
}

export default inject(["app"])(observer(Share))


// WEBPACK FOOTER //
// ./src/components/Share.js